/**
 * Socket handlers for trading events (orders, trades, price ticks).
 */
export function handleOrderUpdated(payload, ctx) {
  if (payload?.order == null) return;
  const next = { order: payload.order, ts: payload.ts ?? Date.now() };
  ctx.setLastOrderUpdate((prev) => {
    if (prev && JSON.stringify(prev.order) === JSON.stringify(next.order)) return prev;
    return next;
  });
}

export function handleTradeExecuted(payload, ctx) {
  if (payload?.price == null || payload?.propertyId == null) return;
  const pid = String(payload.propertyId);
  const nextTick = { price: payload.price, ts: payload.ts ?? Date.now() };
  ctx.setPriceTicks((prev) => {
    const existing = prev[pid];
    if (existing && existing.price === nextTick.price) return prev;
    return { ...prev, [pid]: nextTick };
  });
  const h = ctx.propertyHandlersRef?.current?.[pid];
  if (h?.onTradeExecuted) h.onTradeExecuted(payload);
}

export function handlePriceTick(payload, ctx) {
  if (payload?.propertyId == null || payload?.price == null) return;
  const pid = String(payload.propertyId);
  const nextTick = { price: payload.price, ts: payload.ts ?? Date.now() };
  ctx.setPriceTicks((prev) => {
    const existing = prev[pid];
    if (existing && existing.price === nextTick.price) return prev;
    return { ...prev, [pid]: nextTick };
  });
  const h = ctx.propertyHandlersRef?.current?.[pid];
  if (h?.onPriceTick) h.onPriceTick(payload);
}
